import { PAGINATION } from 'constants/pagination';

export const GROUPS_PAGE_SIZE = PAGINATION.PAGE_SIZE;

export const COMPANY_STATUS = {
  INACTIVE: 1,
  DEMO: 2,
  IN_TRIAL: 3,
  PAYING_CUSTOMER: 4,
  OUTSIDE_COMPANY: 5,
};

export const COMPANY_STATUS_LABEL = {
  [COMPANY_STATUS.INACTIVE]: 'Inactive',
  [COMPANY_STATUS.DEMO]: 'Demo',
  [COMPANY_STATUS.IN_TRIAL]: 'In Trial',
  [COMPANY_STATUS.PAYING_CUSTOMER]: 'Paying Customer',
  [COMPANY_STATUS.OUTSIDE_COMPANY]: 'Outside Company',
};

export const COMPANY_STATUS_OPTIONS = [
  {
    value: COMPANY_STATUS.INACTIVE,
    label: COMPANY_STATUS_LABEL[COMPANY_STATUS.INACTIVE],
  },
  {
    value: COMPANY_STATUS.DEMO,
    label: COMPANY_STATUS_LABEL[COMPANY_STATUS.DEMO],
  },
  {
    value: COMPANY_STATUS.IN_TRIAL,
    label: COMPANY_STATUS_LABEL[COMPANY_STATUS.IN_TRIAL],
  },
  {
    value: COMPANY_STATUS.PAYING_CUSTOMER,
    label: COMPANY_STATUS_LABEL[COMPANY_STATUS.PAYING_CUSTOMER],
  },
  {
    value: COMPANY_STATUS.OUTSIDE_COMPANY,
    label: COMPANY_STATUS_LABEL[COMPANY_STATUS.OUTSIDE_COMPANY],
  },
];

export const TABLE_ACTIONS = {
  SORT: 'sort',
  PAGINATE: 'paginate',
  FILTER: 'filter',
};

export const COMPANY_EMPTY_CONTENT = {
  [COMPANY_STATUS.OUTSIDE_COMPANY]: {
    info: 'You are adding an outside company.',
    note: ['These companies are not part of our system,', 'and do not have associated users.'],
  },
  [COMPANY_STATUS.DEMO]: {
    info: 'Adding a demo company',
    note: ['Demo companies don’t include mystery shop schedule', 'since they are for demonstration only.'],
  },
};
